import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  DELETE_RECIPE,
  GET_RECIPES,
  UPDATE_RECIPE_AVAILABILITY,
  UPDATE_RECIPE_POSITION,
} from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import FilledButton from "components/InterstellrComponents/FilledButton";
import { TiPlus } from "react-icons/ti";
import AddRecipe from "./Modals/AddRecipeModal";
import CategoryWithRecipes from "./CategoryWithRecipes";
import { Overlay } from "snapdrag";
import RecipeItem from "./RecipeItem";
import EditRecipe from "./Modals/EditRecipeModal";
import Swal from "sweetalert2";

const Recipes = () => {
  const [recipes, setRecipes] = useState([]);
  const [showAddRecipe, setShowAddRecipe] = useState(false);

  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [showEditRecipe, setShowEditRecipe] = useState(false);

  useEffect(() => {
    document.title = "Recipe Editor | Administration Panel | Mind Pulse";
    getRecipes();
  }, []);

  const getRecipes = async () => {
    try {
      const response = await axios.get(GET_RECIPES, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      setRecipes(response?.data?.data);
    } catch (error) {
      console.error("Get Recipes Error: ", error);
      alert(error);
    }
  };

  const updateRecipeAvailability = async (data) => {
    try {
      const response = await axios.post(UPDATE_RECIPE_AVAILABILITY, data, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        return alert(response?.data?.message ?? "");
      }
      getRecipes();
    } catch (error) {
      console.error("Update Recipe Error: ", error);
      alert(error);
    }
  };

  const reorderRecipe = async (data) => {
    console.log(data);

    try {
      const response = await axios.post(UPDATE_RECIPE_POSITION, data, {
        headers: generateURLOptions(),
      });

      if (response?.data?.success === false) {
        return alert(response?.data?.message ?? "");
      }
      getRecipes();
    } catch (error) {
      console.error("Reorder Recipe Error: ", error);
      alert(error);
    }
  };

  const totalRecipes = recipes.reduce(
    (acc, c) => acc + (c.recipes?.length || 0),
    0
  );

  const deleteRecipe = async (id) => {
    Swal.fire({
      title: "Delete Recipe",
      text: "Deleting a Recipe is irreversible. Please confirm you want to delete this item.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete Recipe",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            DELETE_RECIPE,
            { itemId: id },
            { headers: generateURLOptions() }
          );
          if (response?.data?.success === false) {
            return alert(response?.data?.message ?? "");
          }
          getRecipes();
        } catch (error) {
          console.error("Delete Recipes Error:", error);
          alert(error);
        }
      }
    });
  };

  return (
    <>
      <EditRecipe
        isOpen={showEditRecipe}
        onClose={() => setShowEditRecipe(false)}
        item={selectedRecipe}
        onComplete={() => {
          setShowEditRecipe(false);
          getRecipes();
        }}
      />

      <AddRecipe
        isOpen={showAddRecipe}
        onClose={() => setShowAddRecipe(false)}
        onComplete={() => {
          setShowAddRecipe(false);
          getRecipes();
        }}
      />

      <div className="w-full px-8">
        {/* Heading Area */}
        <div className="flex flex-row mt-8">
          <div className="flex flex-col">
            <h4 className="font-medium text-lg">Recipes</h4>
            <p className="font-light text-base">
              {recipes.length} Categories, {totalRecipes} Recipes
            </p>
          </div>
          <div className="flex-1" />
          <div className="w-1/6">
            <FilledButton
              text="Add"
              icon={<TiPlus className="text-white mr-2" />}
              onPress={() => setShowAddRecipe(true)}
              borderRadius={96}
            />
          </div>
        </div>

        {recipes.map((category) => (
          <CategoryWithRecipes
            key={String(category.id)}
            category={category}
            onReorder={reorderRecipe}
            onChangeStatus={updateRecipeAvailability}
            onEditItem={(recipe) => {
              setSelectedRecipe(recipe);
              setShowEditRecipe(true);
            }}
            onDelete={(recipe) => deleteRecipe(recipe._id)}
          />
        ))}

        <Overlay>
          {({ data }) => {
            if (!data?.recipe) return null;
            return (
              <div className="border p-2 bg-white rounded-md shadow-xl opacity-90">
                <RecipeItem
                  item={data.recipe}
                  onChangeStatus={updateRecipeAvailability}
                />
              </div>
            );
          }}
        </Overlay>
      </div>
    </>
  );
};

export default Recipes;
